export default __webpack_public_path__ + "static/media/factory__47.a1873151.jpg";